/**
 * Created by litao on 2018/10/23.
 */
import 'element-ui/lib/theme-chalk/index.css'
import Element from 'element-ui';
import EasyScroll from 'easyscroll';
import routerTable from './router/routerTable';
import routerBefore from './router/routerBefore';
import restApi from './http/restApi';
import httpMocks from './http/mock/intercept';
import scanWraps from './warp';
import JBootComponent from 'jboot-component';
import initEncrypt from "./encrypt";

export default function (context) {
    //安装elementUI
    context.install(Element, {size: 'mini'});

    context.install(JBootComponent, {
        upload: {
            url: '/__api/sys/attachment/upload', //所有上传都请求这个路径
            urlField: 'attachment',
            nameField: 'oldname'
        }
    });

    setTimeout(() => {
        [
            {field: '$success', type: 'success'},
            {field: '$warn', type: 'warning'},
            {field: '$info', type: 'success'},
            {field: '$error', type: 'error'}
        ].forEach(({field, type}) => context.$vue.prototype[field] = message => setTimeout(() => Element.Message({
            message,
            type
        })));
    });

    //安装滚动条插件
    context.install(EasyScroll);

    //请求加密
    context.$configure.set('requestIsEncrypt', false);
    context.$configure.set('httpTimeout', 1000 * 600);

    //内置log打印
    context.$configure.set('inlayLog', process.env.NODE_ENV !== 'production');

    //初始化全局封装
    context.$configure.set('globalWrap', scanWraps(context.utils.extractName));

    //设置http请求需要用到的httpToken的key值
    context.$configure.set('tokenKey', 'sc-token');

    //配置入口文件
    context.$configure.set('rootFileConfigure', function () {
        return {
            instance: function () {
                return require('../Root.vue').default;
            }
        }
    });

    //路由模式
    context.$configure.set('routerMode', 'history');

    //自动注册组件上下文
    context.$configure.set('componentContext', require.context('@/components/', true, /\.vue$/));

    //路由表配置
    context.$configure.set('routerTable', routerTable);

    //跳转之前的拦截
    context.$configure.set('routerBefore', routerBefore.bind(null, context));

    //http请求基础路径
    // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'http://192.168.124.9:6891');
    // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? 'https://erp.shangchi4006999166.com/__api/' : 'https://erp.shangchi4006999166.com/__api/');
    // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'http://tb.wanghuifeng.me/__api/');
    // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'https://kehou330ykt.kejiwang.com/__api/');
    context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'http://127.0.0.1:6891');
    // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'http://192.168.1.23:6891');
    // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'http://192.168.1.23:6891');
    // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'https://lvliang-admin.51xuekexue.com/__api/');
    // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'https://330.e7lu.cn/__api/');


    // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? 'http://parking.wanghuifeng.me/__api' : 'http://parking.wanghuifeng.me/__api');
    // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? 'http://parking.wanghuifeng.me/__api' : 'http://parking.wanghuifeng.me/__api');
    // http://47.105.197.148:6831
    //restApi
    context.$configure.set('restApi', restApi.bind(null, context));

    //httpMocks
    context.$configure.set('httpMocks', httpMocks);


    //是否启用mock
    context.$configure.set('mockFlag', true);

    // //请求异常拦截
    context.$configure.set('httpErrorHandler', function (error, cb) {
        if (error.response && [401, 601, 901].includes((error.response.data || {}).code)) {
            let href = window.location.origin;
            if(href.includes('192.168') || href.includes('localhost')){
                window.location.replace("http://192.168.1.8:8080/login")
            }else if(href.includes('test.')){
                window.location.replace("https://lvliang-index-test.azaitalk.com/login")
            }else {
                window.location.replace("https://lvliang-index.azaitalk.com/login")
            }
            context.$rootInstance.$nextTick(function () {
                context.$rootInstance.$busBroadcast('user-auth-fail', error);
            });
        } else {
            cb();
        }
    });



    initEncrypt(context);
}



// WEBPACK FOOTER //
// ./src/configure/index.js